import { DEV, PROD } from "./constants/defaults";

const build_env = process.env.REACT_APP_STAGE;
export const environment = build_env === "prod" ? PROD : DEV;